import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import ArtistContainer from '../../Artistcontainer/ArtistContainer';
import { IOptions } from '@/data/models/option';
import { IArtist } from '@/data/models/artist';
import { FormGroupProps } from './types';
import ReadOnlyField from '@/components/common/ReadOnlyField/ReadOnlyField';

type Props = FormGroupProps & {
  errorBanner?: boolean;
  labelTitle: string;
  handleArtist: (artistData: IArtist[]) => void;
  artistRoles?: IOptions[];
};

export default function ArtistFormGroup({
  album,
  errorBanner,
  readonly,
  disabled,
  labelTitle,
  fieldHasErrors,
  handleArtist,
  artistRoles,
}: Props) {
  const [artistTooltipKey, setArtistTooltipKey] = useState(
    'tooltip.product.artistName'
  );
  const { t } = useTranslation();

  return (
    <>
      {!readonly ? (
        <FormGroupWithTooltip
          tooltipKey={artistTooltipKey}
          containerWidth={
            artistTooltipKey === 'tooltip.product.artistRole'
              ? 'small'
              : 'medium'
          }
          hasErrors={
            fieldHasErrors('Artist') ||
            fieldHasErrors('Artists') ||
            !!(
              errorBanner &&
              (!album.artists?.length ||
                album.artists.some((a) => !a.name || !a.performerRole))
            )
          }
        >
          <label htmlFor="artist" className="col-sm-3 form-label">
            {labelTitle}
          </label>
          <div className="col-sm-6 product-artist">
            <ArtistContainer
              errorBanner={errorBanner}
              artist={album.artists ?? []}
              handleArtist={handleArtist}
              disabled={disabled}
              artistRoles={artistRoles}
              onFocusName={() =>
                setArtistTooltipKey('tooltip.product.artistName')
              }
              onFocusRole={() =>
                setArtistTooltipKey('tooltip.product.artistRole')
              }
            />
          </div>
        </FormGroupWithTooltip>
      ) : (
        <ReadOnlyField
          id={'artist'}
          labelTitle={t('product.editProduct.artists')}
          mode={'objectValueTypeList'}
          value={album.artists?.map((a) => ({
            name: a.name,
            role: a.performerRole,
          }))}
        ></ReadOnlyField>
      )}
    </>
  );
}
